import React from 'react';
import { List } from 'immutable';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  FadeWrapper,
} from '../../../components';
import HeroBig from '../../../components/HeroBig';

const ALLOWED_WIDE_PARAGRAPHS = [
  'video',
  'accordeon',
  'link_list',
];

const NodeHomePage = ({ entity }) => {
  const donationParagraph = entity.getIn(['field_donation_paragraph', 0], null);

  return (
    <article className="NodeHomePage">
      <HeroBig
        entity={entity}
        donationParagraph={donationParagraph}
      />

      {/* Start of paragraphs */}
      {entity.get('field_paragraphs') ? (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            const paragraphType = paragraph.getIn(['entity', 'type', 0, 'target_id']);
            return (
              <FadeWrapper key={`paragraph:${id}`}>
                <Paragraph
                  id={id}
                  entity={paragraph.get('entity')}
                  wide={ALLOWED_WIDE_PARAGRAPHS.includes(paragraphType)}
                />
              </FadeWrapper>
            );
          })}
        </div>
      ) : null}
      {/* End of paragraphs */}

    </article>
  );
};

export default NodeHomePage;
